import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import Fuse from 'fuse.js'

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class TempTags extends Vue {
	form = {
		tag: '',
	}

	loading = false

	options = {
		tags: [] as Array<any>,
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	async loadTags() {
		const url = [
			'https://locatelliadv.com.br/wp-json/wp/v2/tags?per_page=100&page=1',
			'https://locatelliadv.com.br/wp-json/wp/v2/tags?per_page=100&page=2',
		]

		this.options.tags = []
		this.form.tag = ''

		this.loading = true
		await this.fetchTag(url[0])
		await this.fetchTag(url[1])
		this.loading = false
	}

	async fetchTag(url) {
		const res = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization:
					'Basic YWRtaW4ubGxhYzpkcURhIGNVRkkgUkJLUiBsbGdxIHpHNUMgb054Zw==',
			},
		})

		const data = await res.json()

		data.forEach((item) => {
			const tag = {
				id: item.id,
				name: item.name,
			}

			this.options.tags.push(tag)
		})
	}

	get selectedTag() {
		const option = this.options.tags.find((option) => {
			return this.form.tag === option.id
		})

		return option || { id: null, name: '' }
	}

	copy() {
		navigator.clipboard.writeText(this.selectedTag.id)
		this.$bvToast.toast('ID Copiado!', {
			title: 'ID Copiado!',
			variant: 'success',
			solid: true,
			toaster: 'b-toaster-top-center',
		})
	}

	mounted() {
		this.loadTags()
	}
}
